import { MultiSelectFilter } from "../../../../components/general-filters/MultiSelectFilter";
import type { LogbookSessionItem } from "../../types";

type LogbookServiceFilterProps = {
	sessions: Array<LogbookSessionItem>;
	selectedServiceIds: Array<number>;
	onChange: (serviceIds: Array<number>) => void;
};

export const LogbookServiceFilter = ({ sessions, selectedServiceIds, onChange }: LogbookServiceFilterProps) => {
	const uniqueServices = new Map<number, string>();
	sessions.forEach((s) => {
		if (s.service?.id && !uniqueServices.has(s.service.id)) {
			uniqueServices.set(s.service.id, s.service.name);
		}
	});

	const options = [...uniqueServices.entries()]
		.map(([id, name]) => ({ value: id, label: name }))
		.sort((a, b) => a.label.localeCompare(b.label));

	return (
		<MultiSelectFilter
			label="Sessão Serviço"
			options={options}
			selected={selectedServiceIds}
			onChange={onChange}
		/>
	);
};
